<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف/ویرایش واحد</v-card-subtitle>
        <v-spacer/>
        <v-card-text>


          <v-form  ref="form" @submit.prevent="checkOut" lazy-validation v-model="valid">
            <v-row>

              <v-col
                  cols="12"
                  sm="6"
                  md="4">
                <v-autocomplete
                    :items="modelItems.buildingItems"
                    v-model="modelItems.model.buildingId"
                    @input="getUnitList"
                    dense
                    outlined
                    @change="getUnitList"
                    :error-messages="getError('buildingId')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب مجتمع" />

              </v-col>

              <v-col
                  cols="12"
                  sm="6"
                  md="4">
                <v-autocomplete
                    :items="unitList"
                    v-model="modelItems.model.unitId"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('unitId')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب واحد"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4">

                <v-autocomplete
                    :items="modelItems.userItems"
                    v-model="modelItems.model.userId"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('userId')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="انتخاب شخص"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4">

                <v-autocomplete
                    :items="modelItems.stabilityStatusItems"
                    v-model="modelItems.model.stabilityStatusText"
                    @input="handleInput"
                    dense
                    outlined
                    :error-messages="getError('stabilityStatusText')"
                    auto-select-first  append-icon="fas fa-angle-down"
                    label="وضعیت استقرار"

                />

              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4">
                <date-picker placeholder="تاریخ استقرار" v-model="modelItems.model.stabilityText" color="#3b5694" clearable
                             auto-submit>date-picker placeholder="تاریخ استقرار" v-model="modelItems.model.stabilityText" color="#3b5694" clearable
                             auto-submit>
                </date-picker>
                <span style="color: red" v-if="getError('stabilityText')" v-text="getError('stabilityText')"/>
              </v-col>
              <v-col
                  cols="12"
                  sm="6"
                  md="4">
                <date-picker placeholder="تاریخ خروج" v-model="modelItems.model.exitDateText" color="#3b5694" clearable
                             auto-submit>
                </date-picker>
              </v-col>
               <v-col
                  cols="12"
                  sm="6"
                  md="2">
              <v-switch class="mt-0" :error-messages="getError('owner')" dense color="primary" label="مالک " v-model="modelItems.model.owner"/>
              </v-col>
         <v-col
                  cols="12"
                  sm="6"
                  md="2" >
              <v-switch class="mt-0 " dense color="primary" label="مستأجر " v-model="modelItems.model.tenant"/>
              </v-col>


            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                  small
                  depressed
                  color="primary"
                  class=" p-1 m-1"
                  type="submit"
                  :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                small
                depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import Unit_se from "./Unit_se";

export default {

  props: {
    dialogStatus: {
      default: false,
    },
    isEdit: {
      default: false,
    },
    modelItems: Object,
    unitList:Array

  },
  data() {
    return {
      bindingErrors: [],
      // unitList: [],
      valid: true,
      loading: false,

    }
  },
  methods: {
    handleInput (value) {
      this.$emit('input', value)
    },
    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find( ({ fieldName }) => fieldName === key );
        if(error && error.message ) return  error.message[0]
      }
      return ''
    },
    closed() {
      // if(this.isEdit){
      //   this.$root.$emit('ManagementUser')
      // }
      this.bindingErrors=[]
      this.$emit('update:dialogStatus', false)
      this.$emit('update:isEdit', false)
      this.$root.$emit('Establishment')
      this.loading=false
    },

    checkOut(){
      if(this.isEdit){
        this.save()
      }else {
        Unit_se.checkOut(this.modelItems.model.unitId,this.modelItems.model.buildingId).then(response=>{
        if (response && response.status === 200) {
          this.$confirm('واحدی با این نام وجود دارد ادامه می دهید؟')
              .then(isDestroyed => isDestroyed && this.save())
        }else {
            this.save()
        }
      })
      }
    },
    save(){
      this.loading=true
      Unit_se.save(this.modelItems.model).then(response => {
        if (response && response.status === 200) {
          this.$snack({type: 'success'})
          this.closed()
        }else if (response && response.response.status === 400) {
          this.loading=false
          this.bindingErrors = response.response.data;
        }
      })
    },

    getUnitList(val){
      Unit_se.getUnits(val).then(response=>{
       return  this.unitList=response.data.unitList
      })
    },


  },





}
</script>


